import { Theme, useTheme } from '@mui/material/styles';

import { DefaultColor, Palette } from './manifest';

export type ColorProp = ((theme: Theme) => string | undefined) | Palette;

function isDefaultColor(color: string): color is DefaultColor {
    return Object.keys(DefaultColor).includes(color);
}

interface AnyObject {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

function getValueByPath<T>(obj: AnyObject, path: string): T {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
    return path.split('.').reduce<any>((acc, part) => {
        if (acc && Object.prototype.hasOwnProperty.call(acc, part)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
            return acc?.[part] as T | undefined;
        }

        return undefined;
    }, obj);
}

export function usePaletteColor<T extends ColorProp | undefined>(
    color?: T
): T extends undefined ? undefined : string {
    const theme = useTheme();

    return getPaletteColor(theme, color);
}

export function getPaletteColor<T extends ColorProp | undefined>(
    theme: Theme,
    color?: T
): T extends undefined ? undefined : string {
    if (!color) {
        return undefined as T extends undefined ? undefined : string;
    }

    if (typeof color === 'function') {
        return color(theme) as T extends undefined ? undefined : string;
    }

    if (color === 'inherit') {
        return 'inherit' as T extends undefined ? undefined : string;
    }

    const colorPath = (
        isDefaultColor(color) ? `${color}.main` : color
    ) as Palette;

    return getValueByPath<string>(
        theme.palette,
        colorPath
    ) as T extends undefined ? undefined : string;
}
